import { createContext } from "react";
import { QueueReport } from "../../models/reports.queues";

export const QueueReportsContext = createContext<QueueReport[]>([]);
